import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import EventsManagementPage from "@/pages/admin/EventsManagementPage";

export const Route = createFileRoute("/_admin/admin/events")({
  head: () => pageHead("Admin · Events", "AKIVA admin · events portal.", "/admin/events", true),
  component: EventsManagementPage,
});
